import React, { useEffect } from 'react';
import { number, string } from 'prop-types';
import classNames from 'classnames';
import css from './SkeepersCarouselReviews.module.css';

const SKEEPERS_CAROUSEL_SCRIPT_SRC =
  'https://widgets.rr.skeepers.io/carousel/03c78e48-c424-42d7-8037-773a37af650b/ee86d9b9-b044-47be-967e-8aa10f69d230.js';

const shouldIgnoreSkeepersCarouselRuntimeError = payload => {
  const text = String(payload || '');
  const lowerText = text.toLowerCase();
  const isFailedFetch = lowerText.includes('failed to fetch');
  const hasSkeepersTrace = lowerText.includes('widgets.rr.skeepers.io');
  const hasKnownExtensionTrace = lowerText.includes('frame_ant.js');
  return isFailedFetch && (hasSkeepersTrace || hasKnownExtensionTrace);
};

const SkeepersCarouselReviews = props => {
  const {
    slidesCount = 3,
    title = 'Ils nous ont fait confiance',
    titleClassName,
    className,
    rootClassName,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const handleGlobalError = event => {
      const signature = `${event?.message || ''} ${event?.filename || ''}`;
      if (!shouldIgnoreSkeepersCarouselRuntimeError(signature)) {
        return;
      }
      if (typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    };

    const handleUnhandledRejection = event => {
      const reason = event?.reason;
      const signature = `${reason?.message || reason || ''} ${reason?.stack || ''}`;
      if (!shouldIgnoreSkeepersCarouselRuntimeError(signature)) {
        return;
      }
      if (typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('error', handleGlobalError, true);
      window.addEventListener('unhandledrejection', handleUnhandledRejection, true);
    }

    // Navigation SPA: on force un nouveau chargement pour garantir
    // l'initialisation du carrousel sur la vue courante.
    document
      .querySelectorAll(`script[src="${SKEEPERS_CAROUSEL_SCRIPT_SRC}"]`)
      .forEach(script => script.remove());

    const script = document.createElement('script');
    script.src = SKEEPERS_CAROUSEL_SCRIPT_SRC;
    script.defer = true;
    script.charset = 'utf-8';
    document.body.appendChild(script);

    return () => {
      script.remove();
      if (typeof window !== 'undefined') {
        window.removeEventListener('error', handleGlobalError, true);
        window.removeEventListener('unhandledrejection', handleUnhandledRejection, true);
      }
    };
  }, []);

  return (
    <div className={classes} aria-label="Avis vérifiés">
      <h2 className={classNames(css.title, titleClassName)}>{title}</h2>
      <div className="skeepers_carousel_container" data-slides-count={String(slidesCount)} />
    </div>
  );
};

SkeepersCarouselReviews.propTypes = {
  slidesCount: number,
  title: string,
  titleClassName: string,
  className: string,
  rootClassName: string,
};

export default SkeepersCarouselReviews;
